class AgendaControler {

  constructor() {
    this.version = 1.0;
    this.isLoading = false;
    this.$agenda_block = jQuery( '.block-agenda--filter');
    this.$agenda_filters = null;
    this.$agenda_items = null;
    this.$more_button = null;

    this.current_page = 1;
    this.show_per_page = 0;
    this.total_items = 0;
    this.last_filter = '';
  }

  on_page() {
    return (this.$agenda_block.length);
  }

  init() {
    if ( !this.on_page() ) return;
    let $agenda_filter_bar = jQuery('.agenda-filters');
    this.$agenda_filters = $agenda_filter_bar.find('button');
    this.$agenda_items = jQuery('.agenda-listitem');
    this.total_items = this.$agenda_items.length;

    this.show_per_page = $agenda_filter_bar.attr('data-showperpage');
    this.$agenda_filters.on('click', this.filter_clicked.bind(this));

    this.$more_button = jQuery('.more-button');
    this.$more_button.on('click', this.more_button_clicked.bind(this));

    if( this.total_items > this.show_per_page )
      this.$more_button.show();
  }

  more_button_clicked( e ) {
    if( this.isLoading ) return;
    this.current_page++;
    this.isLoading = true;
    try {
      this.filter_events( this.last_filter );
    } finally {
      this.isLoading = false;
    }
  }

  filter_clicked( e ) {
    if( this.isLoading ) return;
    let $this = jQuery(e.target).closest('button');
    this.isLoading = true;
    try {
      this.$agenda_filters.removeClass('active');
      $this.addClass('active');
      this.last_filter = $this.attr('data-filter');
      this.current_page = 1;
      this.filter_events( this.last_filter );
    } finally {
      this.isLoading = false;
    }
  }

  filter_events( filter_slug ) {
    let found_agenda_items;
    this.$agenda_items.slideUp();

    if( filter_slug == '') {
      found_agenda_items = this.$agenda_items;
    } else {
      found_agenda_items = this.$agenda_items
        .filter( function() {
          let my_eventgroups = jQuery(this).attr('data-eventgroups').split(',');
          return ( my_eventgroups.includes(filter_slug) )
        })
    }

    this.total_items = found_agenda_items.length;
    found_agenda_items
      .slice(0, this.show_per_page * this.current_page )
      .stop().slideDown();

    if( this.total_items > (this.show_per_page * this.current_page) )
      this.$more_button.show();
    else 
      this.$more_button.hide();
  }

}